// extracted by mini-css-extract-plugin
export var box = "_2c-2";
export var checkboxControl = "_2c-0";
export var checkboxRow = "_2c-a";
export var checked = "_2c-3";
export var descriptionSpacer = "_2c-c";
export var disabled = "_2c-4";
export var icon = "_2c-8";
export var input = "_2c-1";
export var labelSpacer = "_2c-b";
export var large = "_2c-7";
export var medium = "_2c-6";
export var small = "_2c-5";
export var text = "_2c-9";